export default "__VITE_ASSET__B2e_5MSe__"